import { h, Component, Fragment } from "preact";

export default class Clock extends Component {
    state = {
        interval: null
    };

    componentWillMount() {
        this.setState({
            interval: setInterval(() => this.setState({}), 1000)
        });
    }

    componentWillUnmount() {
        clearInterval(this.state.interval);
    }

    currentHour() {
        return new Date().toLocaleTimeString([], {
            hour:'2-digit',
            minute:'2-digit',
            second:'2-digit',
            hour12: false
        });
    }

    render() {
        return <div class="inline-block page-clock">
            <i class="fa fa-clock" />
            <span class="inline-block ml-1">{this.currentHour()}</span>
        </div>;
    }
}